import PropTypes from "prop-types";
import DateButton from "../DateButton/DateButton";

Dates.propTypes = {
  loading: PropTypes.bool,
  dates: PropTypes.array,
  selectDate: PropTypes.func,
  currentDate: PropTypes.string,
};

export default function Dates(props) {
  const { loading, dates, selectDate } = props;

  if (loading) {
    return (
      <div className="billboard-dates scroll-bar">
        <p className="billboard-date-label">
          Espera un momento mientras cargamos las fechas.
        </p>
        <div className="billboard-dates-menu-container">
          <div className="billboard-dates-menu" style={{ width: `${7 * 150}px` }}>
            {Array.from({ length: 7 }, (_, index) => (
              <div className="dateButton button" key={index} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!dates.length) {
    return (
      <div className="billboard-dates scroll-bar">
        <h2>Por el momento, no hay fechas disponibles.</h2>
      </div>
    );
  }

  return (
    <div className="billboard-dates scroll-bar">
      <p className="billboard-date-label">Elige la fecha de tu función:</p>
      <div className="billboard-dates-menu-container">
        <div
          className="billboard-dates-menu"
          style={{ width: `${dates.length * 150}px` }}
        >
          {dates.map((date, index) => (
            <DateButton
              key={index}
              name={date.date_string}
              value={date.function_date}
              selectDate={selectDate}
              currentDate={props.currentDate}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
